import {
  BANDWIDTH_MSG_RECEIVED,
  CHANGE_SNAPSHOT,
  CLEAR_INVENTORY,
  CLEAR_LOGS,
  CLEAR_STATE,
  CLEAR_TABS,
  CLONE_SNAPSHOT,
  CLOSE_HOSTNAME,
  CLOSE_SETTINGS_NO_PASSWORDS,
  DELETE_DEVICE,
  DELETE_SNAPSHOT,
  DISABLED_POST_DISCOVERY_ACTIONS_CHANGE,
  DISABLE_START_BTN,
  DISCOVERY_PROCESS_START,
  DISCOVERY_PROCESS_STOP,
  DISCOVERY_TASKS_CHANGE,
  DOWNLOAD_LOG,
  DOWNLOAD_SNAPSHOT,
  ENABLE_START_BTN,
  FETCH_DEVICES,
  FETCH_DISCOVERY_INIT,
  FETCH_HOSTNAME,
  FETCH_LOGS,
  FETCH_SNAPSHOT_DATA,
  FETCH_SNAPSHOT_MANAGEMENT,
  LOAD_SNAPSHOT,
  LOCK_SNAPSHOT,
  NAME_CHANGE,
  NETWORKER_CONSOLE_CLEAR,
  NETWORKER_LOGS_RECEIVED,
  NEW_DEVICE_SAVED,
  NOTE_CHANGE,
  OPEN_NEW_SETTINGS,
  OPEN_SETTINGS,
  RUN_TOPOLOGY_CALCULATION,
  SAVE_INVALID_PASSWORDS,
  SERVER_TS_RECEIVED,
  SET_ACTIVE_MENU_TAB,
  SET_SHAPER_SETTINGS,
  SHOW_ADD_LOADER,
  SHOW_REFRESH_LOADER,
  SNAPSHOT_INFO_RECEIVED,
  SNAPSHOT_STATUS_RECEIVED,
  TASKER_CONSOLE_CLEAR,
  TASKER_LOGS_RECEIVED,
  UNLOAD_SNAPSHOT,
  UNLOCK_SNAPSHOT,
  UPLOAD_SNAPSHOT,
  WORKER_CONSOLE_CLEAR,
  WORKER_LAST_COMMUNICATION,
  WORKER_LOGS_RECEIVED,
} from './constants';

export function fetchSnapshotData() {
  return {
    type: FETCH_SNAPSHOT_DATA,
  };
}

export function changeSnapshot(value) {
  return {
    type: CHANGE_SNAPSHOT,
    payload: {
      value,
    },
  };
}

/*
Expected payload
{
  selectSnapshotKey: ?string, // Pass vCollect._key if you want change the selected snapshot
}
*/
export function fetchSnapshotManagement(payload) {
  return {
    type: FETCH_SNAPSHOT_MANAGEMENT,
    payload,
  };
}

export function loadSnapshot(args) {
  return {
    type: LOAD_SNAPSHOT,
    payload: args,
  };
}

export function unloadSnapshot(args) {
  return {
    type: UNLOAD_SNAPSHOT,
    payload: args,
  };
}

export function deleteSnapshot(args) {
  return {
    type: DELETE_SNAPSHOT,
    payload: args,
  };
}

export function downloadSnapshot(args) {
  return {
    type: DOWNLOAD_SNAPSHOT,
    payload: args,
  };
}

export function runTopologyCalculation(args) {
  return {
    type: RUN_TOPOLOGY_CALCULATION,
    payload: args,
  };
}

export function uploadSnapshot(args) {
  return {
    type: UPLOAD_SNAPSHOT,
    payload: args,
  };
}

export function noteChange(args) {
  return {
    type: NOTE_CHANGE,
    payload: args,
  };
}

export function nameChange(args) {
  return {
    type: NAME_CHANGE,
    payload: args,
  };
}

export function lockSnapshot(args) {
  return {
    type: LOCK_SNAPSHOT,
    payload: args,
  };
}

export function unlockSnapshot(args) {
  return {
    type: UNLOCK_SNAPSHOT,
    payload: args,
  };
}

export function cloneSnapshot(args) {
  return {
    type: CLONE_SNAPSHOT,
    payload: args,
  };
}

export function enableStartBtn() {
  return {
    type: ENABLE_START_BTN,
  };
}

export function disableStartBtn() {
  return {
    type: DISABLE_START_BTN,
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE,
  };
}

export function workerLastCommunication(payload) {
  return {
    payload,
    type: WORKER_LAST_COMMUNICATION,
  };
}

export function newDeviceSaved(payload) {
  return {
    payload,
    type: NEW_DEVICE_SAVED,
  };
}

export function serverTimestampReceived(payload) {
  return {
    payload,
    type: SERVER_TS_RECEIVED,
  };
}

export function taskerClear() {
  return {
    type: TASKER_CONSOLE_CLEAR,
  };
}

export function workerClear() {
  return {
    type: WORKER_CONSOLE_CLEAR,
  };
}

export function netWorkerClear() {
  return {
    type: NETWORKER_CONSOLE_CLEAR,
  };
}

export function bandwidthMsgReceived(payload) {
  return {
    type: BANDWIDTH_MSG_RECEIVED,
    payload,
  };
}

export function snapshotStatusReceived(payload) {
  return {
    type: SNAPSHOT_STATUS_RECEIVED,
    payload,
  };
}

export function taskerLogsReceived(payload = []) {
  return {
    type: TASKER_LOGS_RECEIVED,
    payload,
  };
}

export function workerLogsReceived(payload = []) {
  return {
    type: WORKER_LOGS_RECEIVED,
    payload,
  };
}

export function netWorkerLogsReceived(payload = []) {
  return {
    type: NETWORKER_LOGS_RECEIVED,
    payload,
  };
}

export function snapshotInfoReceived(payload) {
  return {
    type: SNAPSHOT_INFO_RECEIVED,
    payload,
  };
}

export function discoveryProcessStart(payload) {
  return {
    type: DISCOVERY_PROCESS_START,
    payload,
  };
}

export function discoveryProcessStop(id) {
  return {
    type: DISCOVERY_PROCESS_STOP,
    payload: id,
  };
}

export function setSharperSettings(bandwidth) {
  return {
    type: SET_SHAPER_SETTINGS,
    payload: {
      bandwidth,
    },
  };
}

export function networkBandwidthSet(bandwidth) {
  return {
    type: `${SET_SHAPER_SETTINGS}_SUCCESS`,
    payload: {
      bandwidth,
    },
  };
}

export function downloadLog(args) {
  return {
    type: DOWNLOAD_LOG,
    payload: args,
  };
}

export function fetchDiscoveryInit() {
  return {
    type: FETCH_DISCOVERY_INIT,
  };
}

export function fetchHostname(args) {
  return {
    type: FETCH_HOSTNAME,
    payload: args,
  };
}

export function deleteDevice(args) {
  return {
    type: DELETE_DEVICE,
    payload: args,
  };
}

export function closeHostname() {
  return {
    type: CLOSE_HOSTNAME,
  };
}

export function setActiveMenuTab(args) {
  return {
    type: SET_ACTIVE_MENU_TAB,
    payload: args,
  };
}

export function clearTabs() {
  return {
    type: CLEAR_TABS,
  };
}

export function showRefreshLoader(args) {
  return {
    type: SHOW_REFRESH_LOADER,
    payload: args,
  };
}

export function showAddLoader(args) {
  return {
    type: SHOW_ADD_LOADER,
    payload: args,
  };
}

export function fetchDevices(args) {
  return {
    type: FETCH_DEVICES,
    payload: args,
  };
}

export function openNewSettings(args) {
  return {
    type: OPEN_NEW_SETTINGS,
    payload: args,
  };
}

export function openSettings(args) {
  return {
    type: OPEN_SETTINGS,
    payload: args,
  };
}

export function fetchLogs() {
  return {
    type: FETCH_LOGS,
  };
}

export function clearLogs() {
  return {
    type: CLEAR_LOGS,
  };
}

export function clearInventory(args) {
  return {
    type: CLEAR_INVENTORY,
    payload: args,
  };
}

export function saveInvalidPasswords(args) {
  return {
    type: SAVE_INVALID_PASSWORDS,
    payload: args,
  };
}

export function closeSettingsNoPasswords() {
  return {
    type: CLOSE_SETTINGS_NO_PASSWORDS,
  };
}

export function discoveryTasksChange(args) {
  return {
    type: DISCOVERY_TASKS_CHANGE,
    payload: args,
  };
}
export function disabledPostDiscoveryActionsChange(args) {
  return {
    type: DISABLED_POST_DISCOVERY_ACTIONS_CHANGE,
    payload: args,
  };
}
